import { Component, HostListener } from '@angular/core';
import { ActivatedRoute, ActivationEnd, Router, RouterOutlet, NavigationEnd } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { Header } from 'app/common-components/header/header';
import { Footer } from 'app/common-components/footer/footer';
import { Sidebar } from 'app/common-components/sidebar/sidebar';
import { Navbar } from 'app/common-components/navbar/navbar';
import { CommonModule } from '@angular/common';
import { filter } from 'rxjs/operators';
import { NoInternetComponent } from '../pages/auth/no-internet/no-internet';


@Component({
	selector: 'app-root',
	imports: [RouterOutlet, MatButtonModule, Header, Footer, Navbar, Sidebar, CommonModule, NoInternetComponent],
	templateUrl: './app.html',
	styleUrl: './app.scss'
})

export class App {
	protected title = 'Banfiy';

	isHeader: any = '';
	isSidebar: any = '';
	isNavbar: any = '';
	isFooter: any = '';
	currentRoute: string = '';
	screenWidth: any = window.innerWidth;
	fullUrl!: string;
	isOffline = !navigator.onLine;

	constructor(public _route: Router, public rt: ActivatedRoute) {
		this._route.events.pipe(filter(event => event instanceof NavigationEnd))
			.subscribe((event: NavigationEnd) => {
				this.fullUrl = event.urlAfterRedirects;
				// console.log(this.fullUrl)
				if (this.fullUrl.includes('lease-form')) {
					this.currentRoute = 'lease-form'
					this.applyLeaseFormVisibility();
				} else {
					this.currentRoute = this.fullUrl
				}
			});
		this._route.events.subscribe((event: any) => {
			if (event instanceof ActivationEnd) {
				if (event.snapshot.data && Object.keys(event.snapshot.data).length > 0) {
					if (event.snapshot.data['isHeader'] >= 0) {
						this.isHeader = event.snapshot.data['isHeader'];
					}
					if (event.snapshot.data['isSidebar'] >= 0) {
						this.isSidebar = event.snapshot.data['isSidebar'];
					}
					if (event.snapshot.data['isNavbar'] >= 0) {
						this.isNavbar = event.snapshot.data['isNavbar'];
					}
					if (event.snapshot.data['isFooter'] >= 0) {
						this.isFooter = event.snapshot.data['isFooter'];
					}
				}
			}
		});

	}

	@HostListener('window:resize')
	onResize() {
		this.screenWidth = window.innerWidth;
		// console.log('resixze', this.screenWidth)
		this.applyLeaseFormVisibility();
	}

	private applyLeaseFormVisibility() {
		// console.log('he',this.screenWidth, this.currentRoute)
		if (this.currentRoute == 'lease-form' && this.screenWidth < 900) {
			this.isHeader = false;
			this.isFooter = false;
		} else if (this.currentRoute == 'lease-form' && this.screenWidth > 900) {
			this.isHeader = true;
			this.isFooter = true;
		}
	}
	ngOnInit() {
		window.addEventListener('storage', (event) => {
			if (event.key === 'logout-event') {
				this.handleLogout();
			}
		});

		window.addEventListener('online', () => this.handleConnectionChange(true));
		window.addEventListener('offline', () => this.handleConnectionChange(false));
		this.handleConnectionChange(navigator.onLine);
	}

	handleConnectionChange(isOnline: boolean): void {
		this.isOffline = !isOnline;
	}

	retryConnection(): void {
		this.handleConnectionChange(navigator.onLine);
		if (!this.isOffline) {
			this._route.navigateByUrl(this._route.url || '/welcome');
		}
	}
	handleLogout() {
		localStorage.clear();
		this._route.navigate(['/auth/login']);
	}
}
